import { initCustomChip } from '../../customize_chip'

initCustomChip('514')
